"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareDisplay = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const clsx_1 = __importDefault(require("clsx"));
const ShareDisplay = (props) => {
    const { share, title, tooltip, highlight, overclaim } = props;
    let shareColor = '';
    if (share && share >= 100 && share <= 100.06 && !overclaim) {
        shareColor = 'blue';
    }
    else if (overclaim && share && share > 0) {
        shareColor = 'red';
    }
    else if (overclaim && highlight && !share) {
        shareColor = 'green';
    }
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('shares', highlight && shareColor) },
        react_1.default.createElement("span", { className: 'label-with-tooltip' },
            title,
            react_1.default.createElement("span", null, tooltip)),
        react_1.default.createElement("span", { className: 'shares-value' },
            share ? Math.round(share * 100) / 100 : 0,
            "%")));
};
exports.ShareDisplay = ShareDisplay;
